<div class="wrapper">
  <adf-global-application-toolbar> </adf-global-application-toolbar>
  <!-- Full Height Content Container -->
  <main class="content d-flex">
    <adf-sidebar [(isOpen)]="sidebarIsOpen" [isEnabled]="sidebarIsEnabled()">
      <div wideContent>
        <adf-navigation-tree
          [navigationItems]="navigationItems()"
          (action)="onNavigationAction($event)"
          [iconOnly]="false"
        ></adf-navigation-tree>
      </div>
      <div narrowContent>
        <adf-navigation-tree
          [navigationItems]="navigationItems()"
          (action)="onNavigationAction($event)"
          [iconOnly]="true"
        ></adf-navigation-tree>
      </div>
    </adf-sidebar>
    <div class="main-area position-relative">
      @if (isNavigating()) {
        <div class="route-loader-overlay">
          <adf-loading-spinner [size]="'3rem'" />
        </div>
      }
      <div class="main-viewport p-4">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
<adf-toast aria-live="polite" aria-atomic="true" />
